// Copyright (c) 2020 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import * as React from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";

import { IState } from "states/states";
import { IAction } from "actions";
import { Bus, IEnergyMeter, IInput, IModule, IOutput } from "parameter";

interface IModuleExtProps {
  index: number;
  showModuleComment: boolean;
}

interface IModuleProps {
  parameter: IModule;
  value: boolean | undefined;
  inputs: IInput[];
  outputs: IOutput[];
  energymeters: IEnergyMeter[];
}

const mapStateToProps = (state: IState, ownProps: IModuleExtProps) => {
  const props: IModuleProps = {
    parameter: state.parameter!.module[ownProps.index],
    value: state.data.module[ownProps.index],
    inputs: state.parameter!.input,
    outputs: state.parameter!.output,
    energymeters: state.parameter!.energymeter,
  };
  return props;
};

interface IModuleDispatch {}

const mapDispatchToProps = (dispatch: (action: IAction<any>) => void) => {
  const dispatchProps: IModuleDispatch = {};
  return dispatchProps;
};

class ModuleComponent extends React.Component<IModuleExtProps & IModuleProps & IModuleDispatch> {
  public render() {
    return (
      <tr className="moduleitem">
        <td>{this.props.parameter.name}</td>
        <td className="optional2">{this.props.parameter.type}</td>
        <td className="optional">{this.props.parameter.address}</td>
        <td>{this.renderUsage()}</td>
        <td className="value-col">
          {this.props.value === true ? (
            <FormattedMessage id="OK" />
          ) : this.props.value === false ? (
            <FormattedMessage id="Failed" />
          ) : (
            <FormattedMessage id="Unknown" />
          )}
        </td>
        {this.props.showModuleComment && (
          <td className="optional">
            <span>{this.props.parameter.comment}</span>
          </td>
        )}
      </tr>
    );
  }

  private renderUsage() {
    const usageItems: JSX.Element[] = [];
    const inputUsage = this.props.inputs
      .filter((curItem) => curItem.bus === Bus.MODULE && curItem.module === this.props.parameter.id)
      .map((curItem) => curItem.name);
    if (inputUsage.length > 0) {
      usageItems.push(
        <li key="input" title={inputUsage.join(", ")}>
          {inputUsage.length} <FormattedMessage id="Input(s)" />
        </li>,
      );
    }
    const outputUsage = this.props.outputs
      .filter((curItem) => curItem.bus === Bus.MODULE && curItem.module === this.props.parameter.id)
      .map((curItem) => curItem.name);
    if (outputUsage.length > 0) {
      usageItems.push(
        <li key="output" title={outputUsage.join(", ")}>
          {outputUsage.length} <FormattedMessage id="Output(s)" />
        </li>,
      );
    }
    const emUsage = this.props.energymeters
      .filter((curItem) => curItem.bus === Bus.MODULE && curItem.module === this.props.parameter.id)
      .map((curItem) => curItem.name);
    if (emUsage.length > 0) {
      usageItems.push(
        <li key="em" title={emUsage.join(", ")}>
          {emUsage.length} <FormattedMessage id="Energy Meter(s)" />
        </li>,
      );
    }
    return <ul>{usageItems}</ul>;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModuleComponent);
